// The clothing slots, in drawing order, with their names per character (Ken's wardrobe, owner
// 2026-10-01). A slot with no item for a character (Natalka has no jacket) is not shown to them.
export const CLOTH_SLOTS = [
  { id: 'buty',       layer: 'shoes',     label: { natalka: 'Buty',       ken: 'Buty' } },
  { id: 'spodniczka', layer: 'bottom',    label: { natalka: 'Spódnice i spodnie', ken: 'Spodnie' } },
  { id: 'bluzka',     layer: 'top',       label: { natalka: 'Bluzki',     ken: 'Koszulki' } },
  { id: 'kurtka',     layer: 'jacket',    label: { natalka: 'Kurtki',     ken: 'Kurtki' } },
  { id: 'akcesorium', layer: 'accessory', label: { natalka: 'Akcesoria',  ken: 'Akcesoria' } },
];
// Shop / Garderoba order (tops first, as the shop always showed them).
// Drawing order of the avatar's layers, bottom to top, per character. Trousers go OVER the shoes — long trousers' hems
// cover them (Ken: owner 2026-10-02; Natalka too since 2026-10-23, as on the bike). The jacket is over the tee;
// 'accessory_back' sits behind the head. The hair (look/hairArt.mjs) is two layers: 'hair_back' behind everything,
// 'hair' over the clothes and under the hat; the default style's 'neck' (today's skin in its hair, decision 15) right
// over the body, so a collar covers it (any other style draws its own ears there, gate 4b).
const Z_ORDERS = {
  ken: ['hair_back', 'accessory_back', 'base', 'neck', 'shoes', 'bottom', 'top', 'jacket', 'hair', 'accessory'],
  natalka: ['hair_back', 'accessory_back', 'base', 'neck', 'shoes', 'bottom', 'top', 'jacket', 'hair', 'accessory'],
};
export const ALL_LAYERS = Z_ORDERS.natalka;
// Headphones worn round the neck: seen from behind, hair that covers the back of the neck hangs over them, so there
// they draw under the front hair layer (owner, gate 4a, 2026-10-31). The walk sprite and the bike rider both ask this.
const NECK_ITEMS = new Set(['nat_headphones', 'ken_akc_headphones']);
const FROM_BEHIND = new Set(['back', 'back34']);
export const underTheHair = (itemId, view) => NECK_ITEMS.has(itemId) && FROM_BEHIND.has(view);
export const zOrderFor = (character) => Z_ORDERS[character] ?? Z_ORDERS.natalka;
const SHOP_ORDER = ['bluzka', 'kurtka', 'spodniczka', 'buty', 'akcesorium'];

// Ken's items (ken_*) and Natalka's second wardrobe (nat_*, owner 2026-10-05) exist only as walk sheets: their
// cloth_* picture is shop / Garderoba art, never drawn on the body (flat-art mode ?anim=0 shows the plain figure).
export const sheetOnly = (id) => typeof id === 'string' && (id.startsWith('ken_') || id.startsWith('nat_'));

export const slotLabel = (id, character = 'natalka') => CLOTH_SLOTS.find((s) => s.id === id)?.label[character] ?? id;

export function slotsFor(character = 'natalka', catalog = {}) {
  const has = new Set(Object.values(catalog).filter((c) => (c.character ?? 'natalka') === character).map((c) => c.category));
  return SHOP_ORDER.map((id) => CLOTH_SLOTS.find((s) => s.id === id)).filter((s) => has.has(s.id));
}
